import React from 'react';
import PropTypes from 'prop-types';
import * as utilities from './../../utilities/calendarUtilities';

const VacationSlide = (props) => {
  const {
    startDate,
    endDate,
    backgroundColor,
    bidSessionStartDateStr,
    calendarStartDateStr,
    calendarHourWidth,
    handleClick,

  } = props;

  const bidSessionStartDateTs = new Date(bidSessionStartDateStr).getTime();
  const calendarStartDateTs = new Date(calendarStartDateStr).getTime();
  const vacationSlideStartDateTs = (calendarStartDateTs > startDate) ? calendarStartDateTs : startDate;
  const hoursFromCalendarStart = utilities.getHourDiff(calendarStartDateTs, vacationSlideStartDateTs);
  const leftPixelsFromCalendarStart = calendarHourWidth * hoursFromCalendarStart;

  const activityDurationInHours = utilities.getHourDiff(
    vacationSlideStartDateTs,
    endDate
  );
  const activityLengthPx = activityDurationInHours * calendarHourWidth;

  return (
    <div
      className="vacation-slide"
      style={{ backgroundColor, left: leftPixelsFromCalendarStart, width: activityLengthPx }}
      onClick={handleClick}
    />
  );
};

VacationSlide.propTypes = {
  backgroundColor: PropTypes.any,
  bidSessionStartDateStr: PropTypes.any,
  calendarStartDateStr: PropTypes.any,
  handleClick: PropTypes.func.isRequired,
  calendarHourWidth: PropTypes.number,
  startDate: PropTypes.number,
  endDate: PropTypes.number,
};

VacationSlide.defaultProps = {
  backgroundColor: '',
  bidSessionStartDateStr: null,
  calendarStartDateStr: null,
  calendarHourWidth: 0,
  startDate: 0,
  endDate: 0,
};

export default VacationSlide;
